import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvestmentfondsComponent } from './investmentfonds.component';
import { DesignSystemModule } from '@dvag/design-system-angular';
@NgModule({
    declarations: [InvestmentfondsComponent],
    imports: [CommonModule, DesignSystemModule]
})
export class InvestmentfondsModule {}
